// extracted by mini-css-extract-plugin
module.exports = {"filtersBar":"filters-bar-component_filtersBar__1P7v1","centered":"filters-bar-component_centered__1zFOO","filterSelect":"filters-bar-component_filterSelect__3T2oE"};